export default __webpack_public_path__ + "static/media/Picture (2).cf011930.png";